import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, WEBSERVICE } from "../utils/init";
import { showToast, showHttpError } from "../utils/library";
import { Modal } from "react-bootstrap";
import {
  FetchMerchantSettings,
  FetchActivatedVolume,
  UpdateVolumeId,
  UploadFile,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import axios from "axios";

const S = {
  pageWrapper: { padding: "24px 16px 60px" },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageTitle: {
    fontSize: "22px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    padding: "16px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "12px",
  },
  cardHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: "1 1 auto",
    minWidth: 0,
  },
  iconBox: (color) => ({
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    flexShrink: 0,
    background:
      color === "green"
        ? "rgba(16,185,129,0.1)"
        : color === "amber"
        ? "rgba(245,158,11,0.1)"
        : "rgba(99,102,241,0.1)",
    color:
      color === "green" ? "#10b981" : color === "amber" ? "#f59e0b" : "#6366f1",
  }),
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  sectionDesc: { fontSize: "12px", opacity: 0.5, margin: "2px 0 0" },
  btnEdit: {
    padding: "8px 18px",
    background: "transparent",
    border: "1px solid var(--btn-color)",
    color: "var(--btn-color)",
    borderRadius: "10px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  btnDisabled: {
    padding: "8px 18px",
    background: "var(--body-color-less2)",
    border: "none",
    color: "var(--text-color)",
    borderRadius: "10px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "not-allowed",
    opacity: 0.4,
  },
  chargeItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderRadius: "10px",
    background: "var(--body-color)",
    border: "1px solid var(--body-color-less2)",
    marginBottom: "8px",
  },
};

class Limits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      dailyTxnLimit: "",
      monthlyTxnLimit: "",
      currentPlanName: "",
      currentPlanTxnCharges: [],
      plans: [],
      isLightPlanApplied: false,
      isBasicPlanApplied: false,
      isBusinessPlanApplied: false,
      requestedVolumeId: null,
      requestedVolumeStatus: null,
      selectedPlanIdForApply: "",
      showIncreaseVolumeModal: false,
      showTaxModal: false,
      ein: "",
      einDoc: null,
      website: "",
      isWebsiteError: false,
      ownerIdentityDoc: null,
      businessAddressDoc: null,
      inCorpDoc: null,
      permission: "",
      einError: "",
      einDocError: "",
      ownerIdentityDocError: "",
      businessAddressDocError: "",
      inCorpDocError: "",
    };
  }

  componentDidMount() {
    this.renderMerchantSettings();
  }

  renderMerchantSettings = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let currentPlanTxnCharges = response.TXN_CHARGES;
            let txnChargesArr = currentPlanTxnCharges.split(",");
            let txnChargeList = [];
            for (let i = 0; i < txnChargesArr.length; i++) {
              let iter = txnChargesArr[i];
              let iterArr = iter.trim().split(" ");
              txnChargeList.push({ asset: iterArr[0], charge: iterArr[1] });
            }
            this.setState({
              currentPlanTxnCharges: txnChargeList,
              plans: response.plans,
              dailyTxnLimit: response.daily_amount_cap,
              monthlyTxnLimit: response.monthly_transaction_cap,
              currentPlanName: response.volume_name,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  renderActivatedVolumeData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchActivatedVolume(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error && response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response.volume_id == "1") {
              this.setState({
                isLightPlanApplied: true,
                isBasicPlanApplied: false,
                isBusinessPlanApplied: false,
              });
            } else if (response.volume_id == "2") {
              this.setState({
                isLightPlanApplied: false,
                isBasicPlanApplied: true,
                isBusinessPlanApplied: false,
              });
            } else if (response.volume_id == "3") {
              this.setState({
                isLightPlanApplied: false,
                isBasicPlanApplied: false,
                isBusinessPlanApplied: true,
              });
            }
            // Show status badge for the requested plan (31=Pending, 32=Approved, 33=Rejected)
            const reqId = response.requested_volume_id;
            const reqStatus = String(response.requested_volume_status || "");
            if (
              reqId &&
              String(reqId) !== String(response.volume_id) &&
              ["31", "32", "33"].includes(reqStatus)
            ) {
              this.setState({
                requestedVolumeId: String(reqId),
                requestedVolumeStatus: reqStatus,
              });
            } else {
              this.setState({
                requestedVolumeId: null,
                requestedVolumeStatus: null,
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  getPlanDetails = (planName) => {
    let plans = this.state.plans;
    for (let i = 0; i < plans.length; i++) {
      if (planName == plans[i].volume_name) return plans[i];
    }
    return {};
  };

  isValidWebsite = () => {
    let regex =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    this.setState({ isWebsiteError: !regex.test(this.state.website) });
  };

  handleEinChange = (e) => {
    let raw = e.target.value.replace(/[^0-9-]/g, "");

    // Auto-insert dash after 2nd digit
    if (raw.length === 2 && !raw.includes("-") && this.state.ein.length === 1) {
      raw = raw + "-";
    }

    // Prevent more than one dash
    if ((raw.match(/-/g) || []).length > 1) return;

    // Enforce max length (XX-XXXXXXX = 10 chars)
    if (raw.length > 10) return;

    // Dash must be at position 2 if present
    if (raw.includes("-") && raw.indexOf("-") !== 2) return;

    this.setState({ ein: raw, einError: "" });
  };

  validateFile = (file) => {
    if (!file) return null;
    const allowedExts = ["jpg", "jpeg", "png", "pdf"];
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    const ext = file.name.split(".").pop().toLowerCase();
    if (!allowedTypes.includes(file.type) || !allowedExts.includes(ext)) {
      return "Only JPEG, JPG, and PDF files are allowed";
    }
    if (file.size > 5 * 1024 * 1024) {
      return "File size must not exceed 5 MB";
    }
    return null;
  };

  handleFileChange = (file, stateKey, errorKey) => {
    const error = this.validateFile(file);
    if (error) {
      this.setState({ [stateKey]: null, [errorKey]: error });
    } else {
      this.setState({ [stateKey]: file, [errorKey]: "" });
    }
  };

  validateEin = () => {
    const einRegex = /^\d{2}-\d{7}$/;
    if (!this.state.ein) {
      this.setState({ einError: "EIN is required" });
      return false;
    }
    if (!einRegex.test(this.state.ein)) {
      this.setState({
        einError: "EIN must be in format XX-XXXXXXX (e.g. 12-3456789)",
      });
      return false;
    }
    this.setState({ einError: "" });
    return true;
  };

  handleApplyPlan = () => {
    const hasFileErrors =
      this.state.einDocError ||
      this.state.ownerIdentityDocError ||
      this.state.businessAddressDocError ||
      this.state.inCorpDocError;

    if (!this.validateEin() || this.state.einDoc == null || hasFileErrors) {
      showToast("error", "Please provide EIN and EIN document");
      return;
    }

    let fd = new FormData();
    fd.append("file_1", this.state.einDoc);
    fd.append("file_type_1", 1);
    fd.append("file_2", this.state.ownerIdentityDoc);
    fd.append("file_type_2", 3);
    fd.append("file_3", this.state.businessAddressDoc);
    fd.append("file_type_3", 4);
    fd.append("file_4", this.state.inCorpDoc);
    fd.append("file_type_4", 5);
    fd.append(
      "merchant_id",
      localStorage.getItem(SITENAMEALIAS + "_merchant_id")
    );
    fd.append("volume_id", this.state.selectedPlanIdForApply);
    fd.append("tax_id", this.state.ein);
    fd.append("website", this.state.website);

    this.setState({ showLoader: true });

    axios
      .post(WEBSERVICE + "/merchant/submitVolumeRequest", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      })
      .then((res) => {
        this.setState({ showLoader: false });
        const response = res.data[0];
        if (response.error !== "0") {
          showToast("error", response.error_msg);
        } else {
          showToast("success", "Plan applied successfully - Pending review");
          setTimeout(() => window.location.reload(), 3000);
        }
      })
      .catch((err) => {
        this.setState({ showLoader: false });
        showHttpError(err);
      });
  };

  renderRequestBadge = (planId) => {
    const { requestedVolumeId, requestedVolumeStatus } = this.state;
    if (requestedVolumeId !== String(planId)) return null;
    if (requestedVolumeStatus === "31") {
      return (
        <span
          style={{
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: "700",
            background: "rgba(245,158,11,0.12)",
            color: "#f59e0b",
            border: "1px solid rgba(245,158,11,0.3)",
          }}
        >
          Requested and waiting for review
        </span>
      );
    }
    if (requestedVolumeStatus === "32") {
      return (
        <span
          style={{
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: "700",
            background: "rgba(16,185,129,0.12)",
            color: "#10b981",
            border: "1px solid rgba(16,185,129,0.3)",
          }}
        >
          ✓ Approved
        </span>
      );
    }
    if (requestedVolumeStatus === "33") {
      return (
        <span
          style={{
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: "700",
            background: "rgba(239,68,68,0.12)",
            color: "#ef4444",
            border: "1px solid rgba(239,68,68,0.3)",
          }}
        >
          ✗ Declined - Please resubmit
        </span>
      );
    }
    return null;
  };

  render() {
    return (
      <Fragment>
        <style>{`
          @media (max-width: 480px) {
            .limits-page-wrapper { padding: 16px 12px 48px !important; }
            .limits-card { padding: 12px !important; }
            .limits-btn-edit { padding: 7px 12px !important; font-size: 11px !important; white-space: nowrap; }
          }
        `}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={S.pageWrapper} className="limits-page-wrapper">
              {/* Header */}
              <div style={S.headerRow}>
                <div>
                  <h2 style={S.pageTitle}>Limits</h2>
                  <div style={S.pageSubtitle}>
                    Approved revenue volume and transaction limits
                  </div>
                </div>
              </div>

              {/* Approved Volume Card */}
              <div style={S.card} className="limits-card">
                <div style={S.cardHeader}>
                  <div style={S.cardHeaderLeft}>
                    <div style={S.iconBox("green")}>
                      <i
                        className="mdi mdi-speedometer"
                        style={{ fontSize: 20 }}
                      ></i>
                    </div>
                    <div>
                      <h3 style={S.sectionTitle}>Approved Volume</h3>
                      <p style={S.sectionDesc}>
                        Your current transaction limits
                      </p>
                    </div>
                  </div>
                  <button
                    style={S.btnEdit}
                    className="limits-btn-edit"
                    onClick={() => {
                      this.renderActivatedVolumeData();
                      this.setState({ showIncreaseVolumeModal: true });
                    }}
                  >
                    <i className="mdi mdi-pencil-outline"></i> Change Plan
                  </button>
                </div>

                <div style={{ marginBottom: "16px" }}>
                  <div
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      background: "var(--body-color)",
                      border: "1px solid var(--body-color-less2)",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        opacity: 0.6,
                        marginBottom: "6px",
                      }}
                    >
                      Current Plan
                    </div>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "var(--btn-color)",
                      }}
                    >
                      {this.state.currentPlanName || "—"}
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <div
                    style={{
                      flex: "1 1 140px",
                      minWidth: 0,
                      padding: "16px 12px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 92%), color-mix(in srgb, var(--btn-color), transparent 96%))",
                      border:
                        "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        opacity: 0.6,
                        marginBottom: "8px",
                      }}
                    >
                      Daily Limit
                    </div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "var(--btn-color)",
                        wordBreak: "break-all",
                      }}
                    >
                      $ {Number(this.state.dailyTxnLimit).toLocaleString()}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        opacity: 0.5,
                        marginTop: "4px",
                      }}
                    >
                      per day
                    </div>
                  </div>
                  <div
                    style={{
                      flex: "1 1 140px",
                      minWidth: 0,
                      padding: "16px 12px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, rgba(16,185,129,0.08), rgba(16,185,129,0.03))",
                      border: "1px solid rgba(16,185,129,0.2)",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        opacity: 0.6,
                        marginBottom: "8px",
                      }}
                    >
                      Monthly Limit
                    </div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#10b981",
                        wordBreak: "break-all",
                      }}
                    >
                      {Number(this.state.monthlyTxnLimit).toLocaleString()}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        opacity: 0.5,
                        marginTop: "4px",
                      }}
                    >
                      payments per month
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>

        {/* ═══ Increase Volume Modal ═══ */}
        <Modal
          show={this.state.showIncreaseVolumeModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="d-flex justify-content-center">
            <Modal.Title>Approved Volume</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ml-4">
              <div className="mb-4">
                <label className="text-primary mb-2">Light Plan</label>
                <p>
                  <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                  Total $
                  {Number(
                    this.getPlanDetails("Light Plan").daily_amount_cap
                  ).toLocaleString()}{" "}
                  a day and{" "}
                  {this.getPlanDetails("Light Plan").monthly_transaction_cap < 0
                    ? "unlimited"
                    : Number(
                        this.getPlanDetails("Light Plan")
                          .monthly_transaction_cap
                      ).toLocaleString()}{" "}
                  payments in a month.
                </p>
                {this.state.isLightPlanApplied ? (
                  <span className="text-success">Activated</span>
                ) : (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <button
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "1",
                          showTaxModal: true,
                        });
                      }}
                      className="btn btn-primary"
                    >
                      Apply
                    </button>
                    {this.renderRequestBadge("1")}
                  </div>
                )}
              </div>
              <hr />
              <div className="mb-4">
                <label className="text-primary mb-2">Basic Plan</label>
                <p>
                  <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                  Total $
                  {Number(
                    this.getPlanDetails("Basic Plan").daily_amount_cap
                  ).toLocaleString()}{" "}
                  a day and{" "}
                  {this.getPlanDetails("Basic Plan").monthly_transaction_cap < 0
                    ? "unlimited"
                    : Number(
                        this.getPlanDetails("Basic Plan")
                          .monthly_transaction_cap
                      ).toLocaleString()}{" "}
                  payments in a month.
                </p>
                <p>
                  <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                  Merchant needs Valid Govt issued Tax ID and a functioning
                  online website.
                </p>
                {this.state.isBasicPlanApplied ? (
                  <span className="text-success">Activated</span>
                ) : (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "2",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      Apply
                    </button>
                    {this.renderRequestBadge("2")}
                  </div>
                )}
              </div>
              <hr />
              <div className="mb-4">
                <label className="text-primary mb-2">Business Plan</label>
                <p>
                  <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                  Total $
                  {Number(
                    this.getPlanDetails("Business Plan").daily_amount_cap
                  ).toLocaleString()}{" "}
                  a day and{" "}
                  {this.getPlanDetails("Business Plan")
                    .monthly_transaction_cap < 0
                    ? "unlimited"
                    : Number(
                        this.getPlanDetails("Business Plan")
                          .monthly_transaction_cap
                      ).toLocaleString()}{" "}
                  payments in a month.
                </p>
                <p>
                  <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                  Merchant needs to submit.
                </p>
                <p>
                  <i className="mdi mdi-numeric-3-box text-primary mr-2"></i>
                  Valid Govt. issued Tax Id.
                </p>
                <p>
                  <i className="mdi mdi-numeric-4-box text-primary mr-2"></i>
                  Principal/Director/Owner's Photo Identification.
                </p>
                <p>
                  <i className="mdi mdi-numeric-5-box text-primary mr-2"></i>
                  Proof of Business Address.
                </p>
                <p>
                  <i className="mdi mdi-numeric-6-box text-primary mr-2"></i>
                  Incorporation documents/ Business Registration.
                </p>
                {this.state.isBusinessPlanApplied ? (
                  <span className="text-success">Activated</span>
                ) : (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "3",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      Apply
                    </button>
                    {this.renderRequestBadge("3")}
                  </div>
                )}
              </div>
              <hr />
              <div className="mb-4">
                <label className="text-primary mb-2">Enterprise Plan</label>
                <p>
                  <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                  Contact us for more info{" "}
                  <a href="javascript:void(0)">
                    contact@{localStorage.getItem(SITENAMEALIAS + "_exchange")}
                    .com
                  </a>
                </p>
              </div>
              <hr />
            </div>
            <button
              type="button"
              className="btn btn-secondary ml-4"
              onClick={() => {
                this.setState({ showIncreaseVolumeModal: false });
              }}
            >
              Cancel
            </button>
          </Modal.Body>
        </Modal>

        {/* ═══ Tax Document Modal ═══ */}
        <Modal
          show={this.state.showTaxModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Tax Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ml-4">
              <div className="form-group">
                <label>EIN*</label>
                <input
                  type="text"
                  className={`form-control ${
                    this.state.einError
                      ? "is-invalid"
                      : this.state.ein && /^\d{2}-\d{7}$/.test(this.state.ein)
                      ? "is-valid"
                      : ""
                  }`}
                  placeholder="XX-XXXXXXX"
                  value={this.state.ein}
                  onChange={this.handleEinChange}
                  onBlur={this.validateEin}
                  maxLength={10}
                />
                {this.state.einError && (
                  <small className="text-danger">
                    <i className="mdi mdi-alert-circle-outline mr-1" />
                    {this.state.einError}
                  </small>
                )}
                {!this.state.einError && this.state.ein && (
                  <small className="text-muted">
                    Format: XX-XXXXXXX (2 digits, dash, 7 digits)
                  </small>
                )}
              </div>
              {this.state.selectedPlanIdForApply == "3" && (
                <div className="form-group">
                  <label>Website</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Website"
                    defaultValue={this.state.website}
                    onChange={(e) => {
                      this.setState({ website: e.target.value });
                    }}
                    onBlur={this.isValidWebsite}
                  />
                  {this.state.isWebsiteError && (
                    <small className="text-danger">
                      Please insert valid website name
                    </small>
                  )}
                </div>
              )}
              <div className="form-group">
                <label>Please select EIN issuance document</label>
                <input
                  type="file"
                  className={`form-control ${
                    this.state.einDocError ? "is-invalid" : ""
                  }`}
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => {
                    this.handleFileChange(
                      e.target.files[0],
                      "einDoc",
                      "einDocError"
                    );
                  }}
                  placeholder="Select EIN Document"
                />
                <small style={{ fontSize: "11px", opacity: 0.55 }}>
                  Accepted: JPEG, JPG, PNG, PDF · Max 5 MB
                </small>
                {this.state.einDocError && (
                  <div>
                    <small className="text-danger">
                      <i className="mdi mdi-alert-circle-outline mr-1" />
                      {this.state.einDocError}
                    </small>
                  </div>
                )}
              </div>
              {this.state.selectedPlanIdForApply == "3" && (
                <div className="form-group">
                  <label>Principal/Director/Owner's Photo Identification</label>
                  <input
                    type="file"
                    className={`form-control ${
                      this.state.ownerIdentityDocError ? "is-invalid" : ""
                    }`}
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={(e) => {
                      this.handleFileChange(
                        e.target.files[0],
                        "ownerIdentityDoc",
                        "ownerIdentityDocError"
                      );
                    }}
                    placeholder="Select Identity Document"
                  />
                  <small style={{ fontSize: "11px", opacity: 0.55 }}>
                    Accepted: JPEG, JPG, PNG, PDF · Max 5 MB
                  </small>
                  {this.state.ownerIdentityDocError && (
                    <div>
                      <small className="text-danger">
                        <i className="mdi mdi-alert-circle-outline mr-1" />
                        {this.state.ownerIdentityDocError}
                      </small>
                    </div>
                  )}
                </div>
              )}
              {this.state.selectedPlanIdForApply == "3" && (
                <div className="form-group">
                  <label>Incorporation documents/ Business Registration</label>
                  <input
                    type="file"
                    className={`form-control ${
                      this.state.inCorpDocError ? "is-invalid" : ""
                    }`}
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={(e) => {
                      this.handleFileChange(
                        e.target.files[0],
                        "inCorpDoc",
                        "inCorpDocError"
                      );
                    }}
                    placeholder="Select Incorporation Document"
                  />
                  <small style={{ fontSize: "11px", opacity: 0.55 }}>
                    Accepted: JPEG, JPG, PNG, PDF · Max 5 MB
                  </small>
                  {this.state.inCorpDocError && (
                    <div>
                      <small className="text-danger">
                        <i className="mdi mdi-alert-circle-outline mr-1" />
                        {this.state.inCorpDocError}
                      </small>
                    </div>
                  )}
                </div>
              )}
              {this.state.selectedPlanIdForApply == "3" && (
                <div className="form-group">
                  <label>Proof of Business Address</label>
                  <input
                    type="file"
                    className={`form-control ${
                      this.state.businessAddressDocError ? "is-invalid" : ""
                    }`}
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={(e) => {
                      this.handleFileChange(
                        e.target.files[0],
                        "businessAddressDoc",
                        "businessAddressDocError"
                      );
                    }}
                    placeholder="Select Proof of Business Address"
                  />
                  <small style={{ fontSize: "11px", opacity: 0.55 }}>
                    Accepted: JPEG, JPG, PNG, PDF · Max 5 MB
                  </small>
                  {this.state.businessAddressDocError && (
                    <div>
                      <small className="text-danger">
                        <i className="mdi mdi-alert-circle-outline mr-1" />
                        {this.state.businessAddressDocError}
                      </small>
                    </div>
                  )}
                </div>
              )}
              <div className="row">
                <div className="">
                  <button
                    className="btn btn-primary"
                    onClick={this.handleApplyPlan}
                  >
                    Apply
                  </button>
                </div>
                <div className="ml-2">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      this.setState({
                        showTaxModal: false,
                        showIncreaseVolumeModal: true,
                      });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

export default Limits;
